import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  insertCompanyInfo,
  getRenewHistory,
  getCompanyDetails,
  updateRenewForm,
  insertRenewForm,
  getRenewDetails,
} from "./services/organization.services";
import { IRenew, IOrganizationState } from "./organizationModel";

const initialState: IOrganizationState = {
  loading: false,
  formLoading: false,
  error: "",
  OrganizationID: null,
  OrganizationList: [],
  OrganizationDetail: {
    ID: null,
    RegistrationDate: "",
    CompanyName: "",
    GSTNo: "",
    Address: "",
    CityID: null,
    CityName: "",
    StateID: null,
    StateName: "",
    ContactPerson: "",
    EmailID: "",
    MobileNo: "",
    TotalUser: null,
    PaymentType: "",
    Amount: 0,
    ExpiryDate: "",
    CreatedBy: null,
    CreatedDate: "",
  },
  RenewDetails: {
    ID: null,
    RenewDate: "",
    TotalUser: 0,
    PaymentType: "",
    Amount: 0,
    Remarks: "",
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    clearRenewDetails: (state) => {
      state.RenewDetails = initialState.RenewDetails;
    },
    // setBranchID: (state, action) => {
    //   state.BranchID = action.payload;
    // },
    // clearBranchID: (state) => {
    //   state.BranchID = initialState.BranchID;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(getRenewHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getRenewHistory.fulfilled,
      (state, action: PayloadAction<IRenew[]>) => {
        state.loading = false;
        state.OrganizationList = action.payload || [];
      }
    );
    builder.addCase(getRenewHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OrganizationList = [];
    });
    builder.addCase(insertCompanyInfo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertCompanyInfo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertCompanyInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(insertRenewForm.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertRenewForm.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertRenewForm.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateRenewForm.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateRenewForm.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateRenewForm.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCompanyDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCompanyDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.OrganizationDetail = action.payload;
    });
    builder.addCase(getCompanyDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OrganizationDetail = initialState.OrganizationDetail;
    });
    builder.addCase(getRenewDetails.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getRenewDetails.fulfilled, (state, action) => {
      state.formLoading = false;
      state.RenewDetails = action.payload;
    });
    builder.addCase(getRenewDetails.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
      state.RenewDetails = initialState.RenewDetails;
    });
  },
});

export const { clearRenewDetails } = organizationSlice.actions;
export default organizationSlice.reducer;
